export default [
    { id: 0, name: 'Standard Allowance', },
    { id: 1, name: 'Exact' },
    { id: 2, name: 'Outside Size' },
    { id: 3, name: 'Sight Size' },
    {
      id: 4, name: 'Custom',
      isCustom: true
    }
]
